/**
 * Kind of special handling triggered by a
 * {@code DunningTypeLevelSpecialHandling} rule when its selection logic
 * matches a dunning contract.
 *
 * Mirrors backend enum {@code com.mvs.backend.bd.enums.DunningSpecialHandlingType}.
 * Ordinal mapping (MUST match the backend enum):
 *   0 = SB_TRANSFER — transfer to clerk / clerk list
 *   1 = WRITE_OFF    — write-off of the receivable
 *   2 = FREEZE        — freeze the dunning process
 *   3 = MANUAL         — manual processing
 *
 * @ticket bd-dunningtype-overview
 */
export enum DunningSpecialHandlingType {
    SB_TRANSFER,
    WRITE_OFF,
    FREEZE,
    MANUAL
}

/**
 * German UI labels for DunningSpecialHandlingType values.
 */
export const DUNNING_SPECIAL_HANDLING_TYPE_LABELS: Record<DunningSpecialHandlingType, string> = {
    [DunningSpecialHandlingType.SB_TRANSFER]: 'Übergabe Sachbearbeiter',
    [DunningSpecialHandlingType.WRITE_OFF]: 'Abschreibung',
    [DunningSpecialHandlingType.FREEZE]: 'Einfrieren',
    [DunningSpecialHandlingType.MANUAL]: 'Manuelle Bearbeitung'
};
